module.exports = __webpack_public_path__ + "img/primary_5x3_z16.363226bd.svg";